/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Group_Tools_And_ControlInputs */

const en_faq_group_tools_and_control = /** @type {(inputs: Faq_Group_Tools_And_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools & control`)
};

const lv_faq_group_tools_and_control = /** @type {(inputs: Faq_Group_Tools_And_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rīki un kontrole`)
};

/**
* | output |
* | --- |
* | "Tools & control" |
*
* @param {Faq_Group_Tools_And_ControlInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_group_tools_and_control = /** @type {((inputs?: Faq_Group_Tools_And_ControlInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Group_Tools_And_ControlInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_group_tools_and_control(inputs)
	return en_faq_group_tools_and_control(inputs)
});